import { render, staticRenderFns } from "./regionCost.vue?vue&type=template&id=b0562ad2&scoped=true&"
import script from "./regionCost.vue?vue&type=script&lang=js&"
export * from "./regionCost.vue?vue&type=script&lang=js&"
import style0 from "./regionCost.vue?vue&type=style&index=0&id=b0562ad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0562ad2",
  null
  
)

export default component.exports